import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';

import API from 'api';
import {
  LoginErrorModel,
  FullIdentityLoginResponseModel,
  UserLoginViewModel,
} from 'api/utility/utility.model';

export const useFullIdentityLoginMutation = (
  options: UseMutationOptions<
    FullIdentityLoginResponseModel,
    AxiosError<LoginErrorModel>,
    UserLoginViewModel
  >
) =>
  useMutation<FullIdentityLoginResponseModel, AxiosError<LoginErrorModel>, UserLoginViewModel>(
    (data) => API.utility.postFullIdentityLogin(data),
    options
  );
